module.exports = __webpack_public_path__ + "img/EndSessionSmiley.c7e2dab5.svg";